import { useEffect } from "react";
import { finishAppSplash } from "./SplashController";

// 실제 화면이 마운트되는 순간(Suspense 경계 해소 포함) 앱 셸 스플래시(#app-splash)를
// 걷는다. 로딩 게이트(세션 판정 중 · lazy 청크 로딩 중)에는 이 컴포넌트가 렌더되지
// 않으므로, 마운트됐다는 건 "보여줄 진짜 화면이 준비됐다"는 신호다. 종단 화면마다
// 형제로 두거나(정적 화면) Suspense 경계 안쪽에 둔다(lazy 화면). finishAppSplash 는
// 멱등(finished 가드)이라 여러 마커/StrictMode 이중 마운트에도 안전하다.
export function SplashDismissOnMount() {
  useEffect(() => {
    void finishAppSplash();
  }, []);
  return null;
}
